import { render, staticRenderFns } from "./DataBody1.vue?vue&type=template&id=37a0fd82&scoped=true&"
import script from "./DataBody1.vue?vue&type=script&lang=js&"
export * from "./DataBody1.vue?vue&type=script&lang=js&"
import style0 from "./DataBody1.vue?vue&type=style&index=0&id=37a0fd82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a0fd82",
  null
  
)

export default component.exports